import CryptoES from 'crypto-es';

import { NormalizedMatchData } from '../components/data_types/types';


const INDEXEDDB_SECRET: string = process.env.REACT_APP_IndexedDB_Secret || '';


export const encryptMatchData = (jsonObj: NormalizedMatchData): string=> {
    return CryptoES.AES.encrypt(JSON.stringify(jsonObj), INDEXEDDB_SECRET).toString();
};


export const decryptMatchData = (ciphertext: string): NormalizedMatchData=> {
    const bytes = CryptoES.AES.decrypt(ciphertext, INDEXEDDB_SECRET);
    const str = bytes.toString(CryptoES.enc.Utf8);

    return JSON.parse(str);
};
